<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container" v-bind:class="modalSize">
                    <div class="modal-header">
                        <slot name="header"></slot>
                    </div>
                    <div class="modal-body text-center">
                        <slot name="body"></slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "modal",
        props: ["modalSize"],
        methods: {}
    };
</script>

<style lang="scss">
    .modal-header {
        margin-top: -10px;
        margin-bottom: -20px;
    }

    .modal-mask {
        position: fixed;
        z-index: 10;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .modal-container-lg {
        width: 65% !important;
        max-width: 500px !important;
        overflow-y: auto;
    }

    .modal-container-xl {
        width: 80% !important;
        max-width: 1200px !important;
    }

    .md-tabs-navigation {
        padding: 5px !important;
    }
</style>
